module.exports = __webpack_public_path__ + "img/4-1.b0008387.jpg";